<template>
  <section>
    <m-table-list
      ref="tableList"
      :fetch-list-func="fetchListFunc"
      :search-form.sync="filters"
    >
      <template v-slot:search-items>
        <m-search-panel
          @searchBoxChange="handleSearch"
          isShowOpenButton
          @keyup.enter.native="handleSearch()"
        >
          <div slot="title">快速筛选</div>
          <div class="filters">
            <div class="query-item-all">
              <div class="filter-item">
                <div class="demonstration">工单编号</div>
                <el-input
                  v-model="filters.workOrderId"
                  placeholder="编号"
                ></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单状态</div>
                <el-select
                  v-model="filters.status"
                  placeholder="全部"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in statusOptions"
                    :key="index"
                    :value="item.code"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">审批状态</div>
                <el-select v-model="filters.handleResult" placeholder="全部">
                  <el-option
                    v-for="(item, index) in handleResultOptions"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">质检状态</div>
                <el-select
                  v-model="filters.qaTestStatus"
                  placeholder="全部"
                  clearable
                >
                  <el-option
                    v-for="item in qaTestStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">提交时间</div>
                <el-date-picker
                  v-model="timeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="timestamp"
                  @change="handleTimeChange"
                ></el-date-picker>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单分类</div>
                <el-select
                  v-model="filters.parentQaTypeId"
                  @change="handleWkOrderChange"
                  placeholder="请选择工单分类"
                  clearable
                >
                  <el-option
                    v-for="item in wkOrderTypeOptions"
                    :key="item.parentTypeId"
                    :label="item.parentQaTypeName"
                    :value="item.parentTypeId"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单类型</div>
                <el-select
                  v-model="filters.qaTypeId"
                  :disabled="!filters.parentQaTypeId"
                  placeholder="请先选择工单分类"
                  clearable
                >
                  <el-option
                    v-for="item in qaTypeOptions"
                    :key="item.qaTypeId"
                    :label="item.qaTypeName"
                    :value="item.qaTypeId"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="filter-item buttons">
              <el-button
                type="primary"
                size="small"
                class="query-btn"
                @click="handleSearch"
              >
                查询
              </el-button>
              <el-button
                type="primary"
                size="small"
                plain
                @click="handleClearSearchForm"
              >
                重置
              </el-button>
              <el-button
                size="medium"
                round
                class="export-btn"
                @click="exportData"
              >
                导出数据
              </el-button>
            </div>
          </div>
        </m-search-panel>
      </template>
      <template v-slot:page-title>
        <div class="page-tabe-title">
          <div class="right">
            <span class="line"></span>
            <div>数据列表</div>
          </div>
        </div>
      </template>
      <template v-slot:table-columns>
        <el-table-column
          label="工单编号"
          prop="wkOrderId"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="问题标题"
          show-overflow-tooltip
          prop="wkOrderTopic"
        ></el-table-column>
        <el-table-column
          label="工单类型"
          prop="qaTypeName"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="提交人" prop="authorName"></el-table-column>
        <el-table-column label="承接人" prop="acceptorName"></el-table-column>
        <el-table-column
          label="提交时间"
          prop="submitTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="审批状态"
          prop="handleResult"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.handleResult"
              size="mini"
              :type="handleResultEnum[scope.row.handleResult].type"
            >
              {{ handleResultEnum[scope.row.handleResult].label }}
            </el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="工单状态" prop="status">
          <template slot-scope="scope">
            <el-tag size="mini" :type="statusEnum[scope.row.status].type">
              {{ statusEnum[scope.row.status].label }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="质检状态" prop="qaTestStatus">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="qaTestStatusEnum[scope.row.qaTestStatus].type"
            >
              {{ qaTestStatusEnum[scope.row.qaTestStatus].label }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="质检日期"
          prop="qaTestDate"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.qaTestDate || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="质检分数" prop="qaTestScore">
          <template slot-scope="scope">
            {{ scope.row.qaTestScore || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="140px">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="small"
              @click="
                $router.push({
                  name: 'workmange.workQuality.detail',
                  query: { wkOrderId: row.wkOrderId, id: row.id },
                })
              "
            >
              质检
            </el-button>
            <el-button
              type="text"
              size="small"
              style="color: #f56c6c"
              @click="showQualityDetail(row.wkOrderId)"
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </template>
    </m-table-list>

    <el-dialog
      title="质检详情"
      @close="handleCloseDialog"
      :visible.sync="dialogTableVisible"
    >
      <div class="dialog-main-content">
        <h2>
          质检得分：
          <span class="color-green">{{ qualityInfo.qaTestScore }}</span>
        </h2>
        <div class="create-form">
          <div
            v-for="(item, index) in qualityInfo.scoreInfo"
            :key="index"
            class="quality-item"
          >
            <div class="quality-name">
              <span>质检项目名称</span>
              <el-input
                v-model="item.qaTestTypeName"
                maxlength="10"
                readonly
              ></el-input>
            </div>
            <div class="quality-score">
              <span>质检项目分数</span>
              <el-input v-model.number="item.qaTestScore" readonly></el-input>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-other-info">
        <h2>质检评语</h2>
        <el-form label-width="100px" :model="qualityInfo">
          <el-form-item label="质检评语:">
            <el-input
              v-model="qualityInfo.comments"
              type="textarea"
              :rows="5"
              show-word-limit
              :maxlength="500"
              resize="none"
              readonly
            />
          </el-form-item>
          <el-form-item label="质检时间:">
            <span>{{ qualityInfo.qaTestDate }}</span>
          </el-form-item>
          <el-form-item label="质检人:">
            <span>{{ qualityInfo.qaTestUserName }}</span>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import api from "plus/api";
import http from "plus/http";
import tableList from "components/tableList";
import moment from "moment";
import {
  statusEnum,
  statusOptions,
  priorityEnum,
  handleResultEnum,
  handleResultOptions,
  qaTestStatusEnum,
  qaTestStatusOptions,
} from "@/components/data.js";

export default {
  name: "workmange.workQuality.list",
  data() {
    return {
      filters: {
        workOrderId: "",
        qaTestStatus: "",
        applyTimeBegin: "",
        applyTimeEnd: "",
        status: "",
        qaTypeId: "", //工单类型
        parentQaTypeId: "", //工单分类
        handleResult: null, //审核状态
      },
      qualityScore: [],
      qualityInfo: {},
      dialogTableVisible: false,
      timeRange: [],
      qaTypeOptions: [], //工单类型
      wkOrderTypeOptions: [], //工单分类
      statusEnum,
      statusOptions,
      priorityEnum,
      handleResultEnum,
      handleResultOptions,
      qaTestStatusEnum,
      qaTestStatusOptions,
    };
  },
  components: {
    "m-table-list": tableList,
  },
  activated() {
    this.getworkorderparenttypelist();
  },
  methods: {
    fetchListFunc: api.workmanage.getPagedList,
    getworkorderparenttypelist() {
      api.dropDownList.getWorkCut().then((res) => {
        this.wkOrderTypeOptions = res.data.data;
      });
    },
    handleWkOrderChange(val) {
      this.filters.qaTypeId = "";
      api.dropDownList.getWorkType({ id: val }).then((res) => {
        this.qaTypeOptions = res.data.data;
      });
    },
    exportData() {
      let url = `/work_order/QaTests/export?workOrderId=${this.filters.workOrderId}&qaTestStatus=${this.filters.qaTestStatus}&status=${this.filters.status}&qaTypeId=${this.filters.qaTypeId}&parentQaTypeId=${this.filters.parentQaTypeId}`;
      if (this.filters.applyTimeBegin) {
        let time = moment(this.filters.applyTimeBegin).format("YYYY-MM-DD");
        url += `&applyTimeBegin=${time}`;
      }
      if (this.filters.applyTimeEnd) {
        let time = moment(this.filters.applyTimeEnd).format("YYYY-MM-DD");
        url += `&applyTimeEnd=${time}`;
      }
      http
        .get(url, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          responseType: "blob",
        })
        .then(function (res) {
          const blob = new Blob([res.data]);
          const fileName = "工单质检导出数据.xlsx";
          const linkNode = document.createElement("a");
          linkNode.download = fileName; //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none";
          linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
          document.body.appendChild(linkNode);
          linkNode.click(); //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href); // 释放URL 对象
          document.body.removeChild(linkNode);
          // if (res.data) {
          //   gp.$baseMessage(`导出成功`, 'success', 'vab-hey-message-success')
          // } else {
          //   gp.$baseMessage(res.data.msg, 'error', 'vab-hey-message-error')
          // }
          // state.uploading2 = false
          // state.upload2.uploadFiles = []
        })
        .catch(function (err) {
          console.error(err);
        });

      // window.location.href =url;
    },
    handleSearch() {
      this.$refs.tableList.handleSearch();
    },
    handleClearSearchForm() {
      this.$refs.tableList.resetSearchForm();
      this.timeRange = [];
    },
    handleTimeChange(val) {
      if (val) {
        const startTime = val[0];
        const endTime = val[1] + 60 * 60 * 1000 * 24 - 1;
        this.filters.applyTimeBegin = new Date(startTime);
        this.filters.applyTimeEnd = new Date(endTime);
      } else {
        this.filters.applyTimeBegin = "";
        this.filters.applyTimeEnd = "";
        this.timeQuantum = [];
      }
    },
    showQualityDetail(id) {
      this.dialogTableVisible = true;
      api.workmanage
        .getQaTestByWorkOrderId(id)
        .then((res) => {
          const data = res.data.data;
          const tempData = {
            scoreInfo: [],
            qaTestScore: data.qaTestScore,
            qaTestDate: this.timeFormat(data.qaTestDate),
            acceptorName: data.acceptorName,
            comments: data.qaTestComments,
            qaTestUserName: data.qaTestUserName,
          };
          for (let item of data.qaTestDetailInfoVos) {
            tempData.scoreInfo.push({
              qaTestTypeName: `${item.qaTestTypeName}(${item.qaTestTypeScore})`,
              qaTestScore: item.qaTestScore,
            });
          }
          this.qualityInfo = tempData;
        })
        .catch((err) => {});
    },
    handleCloseDialog() {
      this.dialogTableVisible = false;
      this.qualityInfo = {};
    },
    deleteRow(id) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass: "confirmBtn",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api.manage.deleteUser({ userId: id }).then(() => {
          this.$message.success("删除成功");
          this.$refs.tableList.getMainData();
        });
      });
    },
    timeFormat(date) {
      if (date) {
        return new Date(+new Date(date) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
/*/deep/ .el-dialog {
  width: 400px;
}

.el-dialog__body {
  .score-info {
    display: flex;
    justify-content: space-between;

    font-size: 14px;
    margin-bottom: 20px;
  }

  .quality-info {
    padding-right: 20px;

    .quality-info-label {
      margin-left: 30px;
    }
  }
}*/
.export-btn {
  background: #3572e2;
  color: #fff;
}

.quality-setting {
  width: 100%;
  height: 936px;

  .table-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 24px;

    .add-setting-btn {
      font-size: 18px;
      color: #3572e2;
      cursor: pointer;
    }
  }
}

/deep/ .el-dialog {
  width: 750px;

  .el-dialog__header {
    .el-dialog__title {
      font-size: 16px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .el-dialog__body {
    padding: 0;

    .dialog-main-content {
      padding: 9px 24px 15px;
      border-top: 1px solid rgba(0, 0, 0, 0.09);
      border-bottom: 1px solid rgba(0, 0, 0, 0.09);

      h2 {
        margin-bottom: 13px;

        span {
          font-size: 22px;
        }
      }

      .create-form {
        .quality-item {
          display: flex;
          justify-content: space-around;
          margin-bottom: 20px;

          span {
            margin-right: 12px;
          }
        }
      }

      .el-input {
        width: 240px;
      }
    }

    .dialog-other-info {
      padding: 9px 24px 15px;

      .el-form {
        .el-form-item {
          margin-bottom: 0px;
        }
      }
    }
  }
}
</style>
